import { Component, Prop, Vue } from 'vue-property-decorator';
import {  itiHttpService, itiSignalRService, i18n, itiMessageService } from '@/iti-core-vue';
import DxList from 'devextreme-vue/list';
import fileModule from '@/store/modules/file.module';
import moment from 'moment';

@Component({
    components: {    
        DxList,          
    },
})
export default class LastFiles extends Vue {

    @Prop() public mode!: string;
    @Prop() public idArea!: number;
    @Prop() public idType!: number;    

    public get lastFiles(){                
        return fileModule.lastFiles.reverse();
    }

    public mounted() {
        switch(this.mode){
            case "User": {                
                fileModule.getLastFilesFromUser().catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});        
                break;
            }
            case "CollaborativeArea": {                               
                fileModule.getLastFilesByAmbitId(this.idArea) .catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});        
                break;
            }
            case "AreaType": {
                fileModule.getLastFilesFromUserByAreaType(this.idType).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                break;
            }
            default: {                
                itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);        
                break;
            }                    
        }      
    }

    public getDate(date: Date) {          
        if (date.toString().charAt(0) == '0') { 
            return "";
        } else {         
            return moment(date).format('DD-MM-YYYY HH:mm');
        }
    }

    public goToDocumentManagement() {
        if (this.mode == "User" || this.mode == "AreaType") {
            this.$router.push({ name: 'GestionDocumental' });   
            fileModule.setPath(['','']);               
        } else if (this.mode == "CollaborativeArea") {
            fileModule.setPath(['','']);       
            this.$router.push({ name: 'GestionDocumentalAreaColaborativa', params: { collaborativeAreaId: this.idArea.toString() } });            
        }
    }

    public goToFile(e: any) {
        fileModule.setFileToShow(e.itemData);
        this.$router.push({ name: 'GestionDocumentalAreaColaborativa', params: { collaborativeAreaId: e.itemData.ambitId.toString() } });                           
    }
}
